import { Button, Typography } from '@material-ui/core'
import React from 'react'
import { useStyle } from './Style'
import { ErrorPageProps } from './Type'

const LayoutErrorPage: React.FC<ErrorPageProps> = ({
  title,
  image,
  text,
  event,
  buttonLabel,
}): React.ReactElement => {
  const classes = useStyle()

  return (
    <div className={classes.container} data-testid="errorPage">
      <img src={image} alt="Not found" className={classes.image} />
      {/* idk */}
      <Typography variant="body1" className={classes.title} component="div">
        {title}
      </Typography>
      {/* idk */}
      <Typography>{text}</Typography>
      {buttonLabel && event && (
        <Button
          variant="contained"
          color="primary"
          onClick={event}
          disableElevation
          className={classes.button}
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  )
}

export default LayoutErrorPage
